import { Typography } from '@mui/material';
import { Row } from 'further-ui/components/Layout';
import { numberToCurrencyString } from 'further-ui/utils';
import { ConsiderationTypeLabels } from 'further-ui/labels';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { sumBy } from 'lodash';
import { realisation as rules } from 'further-ui/validations';

type Consideration = rules.CreateRealisationFormValues['consideration'][number];

type Props = {
  considerations: Array<Consideration>;
  currency: CurrencyCode;
};

const getConsiderationTotal = (consideration: Consideration) => {
  const allocations = consideration.investorAllocations ?? [];
  return (
    sumBy(allocations, 'receivedConsideration') +
    sumBy(allocations, 'escrowConsideration') +
    sumBy(allocations, 'earnoutConsideration') +
    sumBy(allocations, 'withholdingTaxPayable')
  );
};

const ConsiderationTotals: React.FC<Props> = ({ considerations, currency }) => {
  const grandTotal = sumBy(considerations, getConsiderationTotal);

  return (
    <>
      {considerations.map((consideration) => (
        <Row
          key={consideration.considerationType}
          justify="space-between"
          fullWidth
        >
          <Typography variant="h6" color="grey.600">
            Consideration:{' '}
            {ConsiderationTypeLabels[consideration.considerationType]}
          </Typography>
          <Typography variant="h6">
            {numberToCurrencyString(getConsiderationTotal(consideration), {
              currency,
            })}{' '}
            total value
          </Typography>
        </Row>
      ))}
      <Row justify="space-between" fullWidth>
        <Typography variant="h6" color="grey.600">
          Total realisation value
        </Typography>
        <Typography variant="h6">
          {numberToCurrencyString(grandTotal, { currency })}
        </Typography>
      </Row>
    </>
  );
};

export default ConsiderationTotals;
